"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountChangeMobileVerifySubmitAction = exports.accountChangeMobileVerifyAction = exports.accountChangeMobileRedirectAction = exports.accountChangeMobileUsedAction = exports.accountChangeMobileSuccessAction = exports.accountChangeMobileSubmitAction = exports.accountChangePasswordSuccessAction = exports.accountChangePasswordSubmitAction = exports.authenticateRegisterVerifySubmitAction = exports.authenticateForgetPasswordVerifySubmitAction = exports.authenticateForgetPasswordVerifyAction = exports.getSuccessDialogLoggingScreenName = exports.addListingClickAction = exports.authenticateRegisterSuccessAction = exports.authenticateRegisterSubmitAction = exports.authenticateRegisterVerifyAction = exports.authenticateRegisterClickAction = exports.authenticateForgotpasswordSuccessAction = exports.authenticateForgotpasswordSubmitAction = exports.authenticateForgotpasswordClickAction = exports.authenticateLoginSuccessAction = exports.authenticateLoginSubmitAction = exports.authenticateCommonSubmitAction = exports.authenticateLoginClickAction = exports.authenticateCloseLoginScreen = void 0;
const loggingTypes_1 = require("../types/loggingTypes");
const sendLoggingEvent_1 = require("./sendLoggingEvent");
const customDimensionsClass_1 = require("./customDimensionsClass");
const helpers_1 = require("../../../helpers");
function authenticateCloseLoginScreen() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.SCREEN,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CLOSE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.POPUP,
        referenceEntity: "NA",
        referenceId: "NA",
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        currentWidgetName: loggingTypes_1.EnumWidgets.HEADER,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION,
        closePopup: true,
    });
}
exports.authenticateCloseLoginScreen = authenticateCloseLoginScreen;
function authenticateLoginClickAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LOGIN,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.CLICK,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry")
    });
}
exports.authenticateLoginClickAction = authenticateLoginClickAction;
function authenticateCommonSubmitAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.COMMON,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateCommonSubmitAction = authenticateCommonSubmitAction;
function authenticateLoginSubmitAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LOGIN,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateLoginSubmitAction = authenticateLoginSubmitAction;
function authenticateLoginSuccessAction(memberId) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LOGIN,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateLoginSuccessAction = authenticateLoginSuccessAction;
function authenticateForgotpasswordClickAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.FORGOT_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.CLICK,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateForgotpasswordClickAction = authenticateForgotpasswordClickAction;
function authenticateForgotpasswordSubmitAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.FORGOT_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_RESET_PASSWORD,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateForgotpasswordSubmitAction = authenticateForgotpasswordSubmitAction;
function authenticateForgotpasswordSuccessAction(memberId) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.FORGOT_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_RESET_PASSWORD,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateForgotpasswordSuccessAction = authenticateForgotpasswordSuccessAction;
function authenticateRegisterClickAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.REGISTER,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.CLICK,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateRegisterClickAction = authenticateRegisterClickAction;
function authenticateRegisterVerifyAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.REGISTER,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateRegisterVerifyAction = authenticateRegisterVerifyAction;
function authenticateRegisterSubmitAction() {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.REGISTER,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_FORM,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateRegisterSubmitAction = authenticateRegisterSubmitAction;
function authenticateRegisterSuccessAction(memberId) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.REGISTER,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_FORM,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateRegisterSuccessAction = authenticateRegisterSuccessAction;
function addListingClickAction({ currentScreen, memberId, widgetName }) {
    const logging = customDimensionsClass_1.CustomDimensionsClass.getInstance(currentScreen);
    logging.setSessionFunnelSource(currentScreen);
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ADD,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LISTING,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.CLICK,
        currentScreenName: currentScreen,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        memberId: memberId,
        sessionFunnel: true,
        SessionFunnelPointOfEntry: `${currentScreen}_${widgetName ? widgetName : "NA"}_${loggingTypes_1.EnumUxTypes.BUTTON}`
    });
}
exports.addListingClickAction = addListingClickAction;
const getSuccessDialogLoggingScreenName = (type) => {
    const screenNamesMappers = {
        RETURNING_USER: {
            screenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_LOGIN_SUCCESS,
        },
        NEW_PASSWORD: {
            screenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_RESET_PASSWORD_SUCCESS,
        },
        REGISTER_NEW_USER: {
            screenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_SUCCESS,
        },
        NEW_USER: {
            screenName: loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_SUCCESS,
        },
    };
    return screenNamesMappers[type];
};
exports.getSuccessDialogLoggingScreenName = getSuccessDialogLoggingScreenName;
// actions :
function authenticateForgetPasswordVerifyAction({ currentScreen, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.FORGOT_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY,
        currentScreenName: currentScreen,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        sessionFunnel: true,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateForgetPasswordVerifyAction = authenticateForgetPasswordVerifyAction;
function authenticateForgetPasswordVerifySubmitAction({ currentScreen, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.FORGOT_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY_SUBMIT,
        currentScreenName: currentScreen,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        sessionFunnel: true,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateForgetPasswordVerifySubmitAction = authenticateForgetPasswordVerifySubmitAction;
function authenticateRegisterVerifySubmitAction({ currentScreen, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.AUTHENTICATE,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.REGISTER,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY_SUBMIT,
        currentScreenName: currentScreen,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        sessionFunnel: true,
        SessionFunnelPointOfEntry: (0, helpers_1.getCookie)("sessionFunnelPointOfEntry"),
    });
}
exports.authenticateRegisterVerifySubmitAction = authenticateRegisterVerifySubmitAction;
function accountChangePasswordSubmitAction({ currentScreen, memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: currentScreen,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
        memberId: memberId,
    });
}
exports.accountChangePasswordSubmitAction = accountChangePasswordSubmitAction;
function accountChangePasswordSuccessAction({ currentScreen, memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_PASSWORD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: currentScreen,
        memberId: memberId,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
    });
}
exports.accountChangePasswordSuccessAction = accountChangePasswordSuccessAction;
function accountChangeMobileSubmitAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.MY_ACCOUNT_PROFILE,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileSubmitAction = accountChangeMobileSubmitAction;
function accountChangeMobileSuccessAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.NA,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileSuccessAction = accountChangeMobileSuccessAction;
function accountChangeMobileUsedAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.USED,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.MY_ACCOUNT_PROFILE,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileUsedAction = accountChangeMobileUsedAction;
function accountChangeMobileRedirectAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.REDIRECT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.MY_ACCOUNT_PROFILE,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileRedirectAction = accountChangeMobileRedirectAction;
function accountChangeMobileVerifyAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.ACCOUNT_MOBILE_VERIFY,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileVerifyAction = accountChangeMobileVerifyAction;
function accountChangeMobileVerifySubmitAction({ memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.ACCOUNT,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.CHANGE_MOBILE,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.VERIFY_SUBMIT,
        currentScreenName: loggingTypes_1.EnumLoggingScreenNames.ACCOUNT_MOBILE_VERIFY,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.BUTTON,
        referenceEntity: loggingTypes_1.EnumReferenceEntity.MEMBER,
        referenceId: memberId,
    });
}
exports.accountChangeMobileVerifySubmitAction = accountChangeMobileVerifySubmitAction;
